import React, { useEffect, useState } from 'react'
import { SnackbarProvider } from 'notistack'

import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider } from '@material-ui/styles'

import * as themes from './themes'
import ApplicationRouter from './ApplicationRouter'
import i18n from './i18n'
import { ApplicationContext, ThemeContext } from './contexts'
import { useDarkMode } from './hooks/useDarkMode/useDarkMode'
import { useLocalStorage } from './hooks/useLocalStorage/useLocalStorage'
import { useStyles } from './hooks/useStyles/useStyles'

const styles = (theme) => ({
  root: {
    display: 'flex',
  },

  appBarSpacer: theme.mixins.toolbar,

  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    padding: theme.spacing(3),
  },
})

const useApplicationContextValue = () => {
  const [applicationScreenTitle, setApplicationScreenTitle] = useState(null)
  const [drawerOpen, setDrawerOpen] = useLocalStorage(
    'isApplicationDrawerOpen',
    false,
  )
  const [userLanguage, setUserLanguage] = useLocalStorage(
    'userLanguage',
    'en-us',
  )

  const applicationContextValue = {
    applicationScreenTitle,
    drawerOpen,
    setApplicationScreenTitle,
    setDrawerOpen,
    setUserLanguage,
    userLanguage,
  }

  return applicationContextValue
}

const useThemeContextValue = () => {
  const [, setDarkMode] = useDarkMode()
  const theme = themes.main

  const themeContextValue = {
    darkMode: false,
    theme,
    toggleDarkMode: () => setDarkMode(false),
  }

  return themeContextValue
}

const ApplicationContainer = () => {
  const applicationContextValue = useApplicationContextValue()
  const themeContextValue = useThemeContextValue()

  const { userLanguage } = applicationContextValue
  useEffect(() => {
    if (userLanguage) {
      i18n.changeLanguage(userLanguage)
    }
  }, [userLanguage])

  const classes = useStyles(styles, { theme: themeContextValue.theme })

  return (
    <ApplicationContext.Provider value={applicationContextValue}>
      <ThemeContext.Provider value={themeContextValue}>
        <ThemeProvider theme={themeContextValue.theme}>
          <SnackbarProvider>
            <div className={classes.root}>
              <CssBaseline />

              <ApplicationRouter />
            </div>
          </SnackbarProvider>
        </ThemeProvider>
      </ThemeContext.Provider>
    </ApplicationContext.Provider>
  )
}

export default ApplicationContainer
